import {injectable} from 'inversify';

import type {MembershipModel} from './Membership.model';

import {BaseController} from '../Base/Base.controller';

@injectable()
export class MembershipController extends BaseController<MembershipModel> {
  constructor() {
    super();
  }
}
